/** Models of one vendor that run the same firmware image, recognised by model prefix. */
export interface ChargerFamily {
  key: string;
  label: string;
  modelPrefixes: string[];
}

export interface ChargerVendor {
  vendorPattern: RegExp;
  families: ChargerFamily[];
}

// One entry per hardware vendor; add a family once it is known which models share a firmware image.
export const chargerVendors: ChargerVendor[] = [
  {
    vendorPattern: /^alfen/i,
    families: [
      { key: 'alfen-ng9', label: 'Alfen NG9', modelPrefixes: ['NG9'] },
      { key: 'alfen-ahp', label: 'Alfen AHP', modelPrefixes: ['AHP', 'AHWP'] }
    ]
  }
];
